import cx from 'classnames'
import { CircularAddButtonIcon } from 'icons'
import styles from './CircularAddButton.module.scss'

const CircularAddButton = ({
  ariaLabel,
  className,
  disabled = false,
  isLoading = false,
  onClick,
  size
}) => {
  const sizing = size ? { width: size, height: size } : undefined
  return (
    <button
      type='button'
      aria-label={ariaLabel}
      aria-busy={isLoading}
      className={cx(styles.button, { [styles.loading]: isLoading }, className)}
      disabled={disabled || isLoading}
      onClick={onClick}
      style={sizing}
    >
      <img
        src={CircularAddButtonIcon}
        alt=''
        aria-hidden='true'
        className={styles.icon}
        style={sizing}
      />
    </button>
  )
}

export default CircularAddButton
